import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
// product-hero-parallax.esm.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initProductHeroParallax(root = document) {
    const section = root.querySelector(".productHeroSection");
    if (!section) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const bg = section.querySelector(".productHeroSection__bg");
    if (!bg) return;

    const AMP_DESKTOP = 0.35;   // було 0.25 → стане помітніше
    const AMP_MOBILE  = 0.22;   // на мобі делікатніше
    const BIAS_PX     = 24;     // старт трохи нижче, щоб верх не обрізало

    const mq = window.matchMedia("(max-width: 768px)");
    const rangePx = () => Math.round(window.innerHeight * (mq.matches ? AMP_MOBILE : AMP_DESKTOP));

    gsap.fromTo(bg,
        { backgroundPosition: () => `50% ${BIAS_PX}px` },
        {
            backgroundPosition: () => `50% ${BIAS_PX + rangePx()}px`,
            ease: "none",
            willChange: "background-position",
            scrollTrigger: { trigger: section, start: "top top", end: "bottom top", scrub: true, invalidateOnRefresh: true }
        }
    );

    const btn = section.querySelector(".productHeroSection__scroll");
    if (btn) {
        btn.addEventListener("click", () => {
            const next = section.nextElementSibling;
            if (next) next.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
}

// автозапуск
if (document.readyState !== "loading") initProductHeroParallax();
else document.addEventListener("DOMContentLoaded", () => initProductHeroParallax());

export { initProductHeroParallax };

    function initHeroScroll(root=document){
        root.querySelectorAll('.productHeroSection__scroll').forEach(btn=>{
            const section = btn.closest('.productHeroSection');
            if(!section) return;
            let next = section.nextElementSibling;
            // пропустити технічні порожні елементи
            while (next && next.tagName === 'SCRIPT') next = next.nextElementSibling;

            if(!next){ btn.hidden = true; return; }

            const go = () => next.scrollIntoView({ behavior: 'smooth', block: 'start' });
            btn.addEventListener('click', go);
            btn.addEventListener('keydown', (e)=>{
                if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
            });
        });
    }







    if (document.readyState !== 'loading') initHeroScroll();
    else document.addEventListener('DOMContentLoaded', () => initHeroScroll());


    // assets/js/productImageScrollText.js
    // Пін-секція: правий список скролиться у viewport під висоту зображення.
    // На екранах <1024px анімація вимкнена (все стає в одну колонку).


    // ===== Налаштування =====
    const DESKTOP_BP     = 1024; // брейкпоінт, нижче — без анімації
    const SCRUB_S        = 1.2;  // інерція скролу (сек)
    const SCROLL_FACTOR  = 1.6;  // довжина сцени відносно контенту (більше = повільніше)
    // const OPACITY_MIN    = 0.55; // прозорість неактивних пунктів
    const MIN_AVAILABLE  = 240;  // мін. висота viewport праворуч

    function initProductImageScrollText() {
        gsap.registerPlugin(ScrollTrigger);

        const root = document.querySelector(".productImageScrollTextSection");
        if (!root) return;

        const img  = root.querySelector(".productImageScrollTextSection__img");
        const top  = root.querySelector(".productImageScrollTextSection__top");
        const view = root.querySelector(".productImageScrollTextSection__right");
        if (!view) return;

        // створюємо внутрішній шар, який будемо рухати
        let inner = view.querySelector(".productImageScrollTextSection__rightInner");
        if (!inner) {
            inner = document.createElement("div");
            inner.className = "productImageScrollTextSection__rightInner";
            while (view.firstChild) inner.appendChild(view.firstChild);
            view.appendChild(inner);
        }

        const items = Array.from(inner.querySelectorAll(".productImageScrollTextSection__items"));

        // прибити попередні тригери/стилі
        const killPrev = () => {
            ScrollTrigger.getAll().forEach((t) => {
                if (t.vars?.id && t.vars.id.startsWith("pist-")) t.kill(true);
            });
            view.style.height = "";
            view.style.overflow = "";
            view.style.position = "";
            inner.style.transform = "";
            inner.style.willChange = "";
            // items.forEach(el => el.style.opacity = "");
        };

        const setup = () => {
            killPrev();

            // <1024px — робимо звичайний потік (без піну і без штучних висот)
            if (window.innerWidth < DESKTOP_BP) {
                ScrollTrigger.refresh();
                return;
            }

            root.style.minHeight = "100vh";

            // паддінги секції — щоб правильно вирахувати доступну висоту в межах 100vh
            const cs = getComputedStyle(root);
            const padTop = parseFloat(cs.paddingTop) || 0;
            const padBot = parseFloat(cs.paddingBottom) || 0;

            // доступна висота під блок із картинкою + списком
            const available = Math.max(
                MIN_AVAILABLE,
                Math.floor(window.innerHeight - padTop - padBot - (top?.offsetHeight || 0))
            );

            // реальна висота відрендереної картинки
            const imgRect = img ? img.getBoundingClientRect() : { height: available };
            const imgHRendered = Math.round(imgRect.height || available);

            // висота viewport праворуч = мін(доступна, висота картинки)
            const viewportH = Math.min(available, imgHRendered);

            // готуємо viewport та inner
            view.style.height   = viewportH + "px";
            view.style.overflow = "hidden";
            view.style.position = "relative";
            inner.style.willChange = "transform";

            // повна висота контенту та відстань прокрутки
            const contentH = inner.scrollHeight;
            const distance = Math.max(0, contentH - viewportH);

            if (distance <= 0) { ScrollTrigger.refresh(); return; }

            // подовжена сцена для більш повільного руху
            const sceneLen = Math.ceil(distance * SCROLL_FACTOR);

            const tl = gsap.timeline({
                defaults: { ease: "none" },
                scrollTrigger: {
                    id: "pist-pin",
                    trigger: root,
                    start: "top top",
                    end: () => `+=${sceneLen}`,
                    pin: true,
                    scrub: SCRUB_S,
                    invalidateOnRefresh: true,
                    anticipatePin: 1,
                    // markers: true,
                },
            });

            // рухаємо саме inner, а не viewport
            tl.to(inner, { y: -distance }, 0);

            // м’яка підсвітка активного пункту (під довшу сцену)
            let acc = 0;
            items.forEach((el) => {
                const h = el.offsetHeight;
                const from = (acc / distance) * (distance / sceneLen);
                const dur  = (h   / distance) * (distance / sceneLen);

                // gsap.set(el, { opacity: OPACITY_MIN });
                // tl.to(el, { opacity: 1 }, from)
                //     .to(el, { opacity: OPACITY_MIN }, from + dur * 0.9);

                acc += h;
            });

            ScrollTrigger.refresh();
        };

        // ініціалізація коли картинка готова (щоб мати правильні розміри)
        if (img) {
            if (img.complete) setup();
            else img.addEventListener("load", setup, { once: true });
        } else {
            setup();
        }

        // дебаунс: на resize/orientation перераховуємо все
        let rAF;
        const refresh = () => {
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(setup);
        };
        window.addEventListener("resize", refresh, { passive: true });
        window.addEventListener("orientationchange", refresh, { passive: true });
    }



    document.addEventListener("DOMContentLoaded", initProductImageScrollText);



    // ==== Product page reveals (hero — одразу; інше — при доскролі, 1 раз) ====

(function runProductHero() {
    const start = () => {
        const wrap = document.querySelector('.productHeroSection__wrapper');
        const els = [
            '.productHeroSection__subtext',
            '.productHeroSection__title',
            '.productHeroSection__text'
        ].map(sel => wrap.querySelector(sel)).filter(Boolean);

        // миттєвий старт у найближчий кадр рендеру
        requestAnimationFrame(() => {
            gsap.to(els, {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: 0.06,
                lazy: false,
                overwrite: 'auto',
                force3D: true
            });
        });
    };

    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
})();

    function initProductRevealAnimations(root = document) {
        gsap.registerPlugin(ScrollTrigger);

        const ignorePRM = document.documentElement.getAttribute('data-ignore-prm') === '1';
        const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce && !ignorePRM) return;



        // 2) Інші блоки — тільки при доскролі
        //    УВАГА: не чіпаємо картинки та pinned-контейнер правої колонки
        const selectors = [
            // верх pin-секції (тільки текст)
            '.productImageScrollTextSection__title',
            '.productImageScrollTextSection__text',

            // cards (тільки текстові елементи/карточки)
            '.productCardsSection__title',
            '.productCardsSection__item',

            // CTA
            '.basicCTASection__title',
            '.basicCTASection__text',
            '.basicCTASection .btn'
        ];

        const targets = gsap.utils.toArray(selectors.join(',')).filter(el => root.contains(el));
        gsap.set(targets, { autoAlpha: 0, y: 28 });

        targets.forEach((el, i) => {
            const tween = gsap.fromTo(
                el,
                { autoAlpha: 0, y: 28 },
                {
                    autoAlpha: 1, y: 0,
                    duration: 0.6,
                    ease: 'power2.out',
                    immediateRender: false
                }
            );

            ScrollTrigger.create({
                trigger: el,
                start: 'top 82%',
                toggleActions: 'play none none none',
                once: true,
                invalidateOnRefresh: true,
                animation: tween,
                // легка «драбинка» для карточок
                onEnter: () => {
                    if (el.matches('.productCardsSection__item')) tween.delay((i % 4) * 0.06);
                }
                // markers: true,
            });
        });

        // після завантаження зображень/відео — перерахувати позиції, щоб не заважати pin-сцені
        window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    }

    // твій звичний виклик:
    document.addEventListener('DOMContentLoaded', () => initProductRevealAnimations(document));



// якщо ставиш через Yarn:
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

// якщо через CDN — прибери імпорти і лиши ініціалізацію нижче.

function alignCarouselLeftDesktopOnly() {
    // на мобілці не чіпаємо — там 20px у CSS
    if (window.innerWidth < 768) return;
    const section = document.querySelector('.productCarouselSection');
    const cont    = section?.querySelector('.productCarouselSection__cont');
    const bottom  = section?.querySelector('.productCarouselSection__bottom');
    if (!section || !cont || !bottom) return;

    const left = Math.round(cont.getBoundingClientRect().left);
    bottom.style.paddingLeft = left + 'px';                // початок слайдера = початку контейнера
    section.style.setProperty('--pc-cont-pad', left + 'px'); // щоб верхні стрілки були вирівняні праворуч
}

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.productCarousel', {
        loop: true,
        watchOverflow: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },

        // ДЕСKTOP стрілки зверху праворуч
        navigation: {
            nextEl: '.productCarouselSection .pcarousel-next',
            prevEl: '.productCarouselSection .pcarousel-prev',
        },

        // Мобільні dots (під каруселлю)
        pagination: {
            el: '.pcarousel-pagination--m',
            clickable: true
        },

        // Кількість видимих слайдів
        breakpoints: {
            0:    { slidesPerView: 1,   spaceBetween: 16, centeredSlides: false }, // мобілка — рівно 1
            744:  { slidesPerView: 2,   spaceBetween: 20, centeredSlides: false },
            1280: { slidesPerView: 3.2, spaceBetween: 24, centeredSlides: false }, // 3 повних + шматок 4-го
        },

        on: {
            init(){ alignCarouselLeftDesktopOnly(); }
        }
    });

    // Підв’язуємо мобільні кнопки під слайдер (бо Swiper навігація приймає лише один елемент)
    const prevM = document.querySelector('.pcarousel-prev--m');
    const nextM = document.querySelector('.pcarousel-next--m');
    prevM && prevM.addEventListener('click', () => swiper.slidePrev());
    nextM && nextM.addEventListener('click', () => swiper.slideNext());

    // десктопне вирівнювання
    alignCarouselLeftDesktopOnly();
    window.addEventListener('resize', alignCarouselLeftDesktopOnly);
    window.addEventListener('orientationchange', alignCarouselLeftDesktopOnly);
});

